import Component from 'flarum/common/Component';

export default class DiscussionSkeleton extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		return (
			<div className='DiscussionSkeleton DiscussionListItem'>
				<div className='DiscussionListItem-content'>
					<a className='DiscussionListItem-author'>
						<span className='Avatar'></span>
					</a>

					<a className='DiscussionListItem-main'>
						<div className='DiscussionListItem-tags'></div>
						<h3 className='DiscussionListItem-title'></h3>
						<ul className='DiscussionListItem-info'></ul>
					</a>
				</div>
			</div>
		);
	}
}
